import { Component } from "react";
import {
    View,
    TouchableOpacity,
    Image,
    Dimensions,
    ScrollView,
    Linking,
} from "react-native";

import { WHITE } from "react-native-material-color";
import { SafeAreaInsetsContext } from "react-native-safe-area-context";
// import ActionSheet from 'react-native-actionsheet';

import * as Styles from "../utils/Styles";
import * as AppStyles from "../utils/appStyles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import Text from "../components/Text";
import * as Animatable from "react-native-animatable";
import * as ServerOperations from "../utils/ServerOperations";
import loaderHandler from "../components/react-native-busy-indicator/LoaderHandler";
import InvoiceDetails from "./InvoiceDetails";
let height = Dimensions.get("window").height;
let width = Dimensions.get("window").width;
let styles = {};
let isMobile = false;
let scale = 1;
const CloseIcon = require("../images/InvoiceDetails/closeIcon.png");
const imgProfile = require("../images/Header/Profile.png");
const imgJdsLogo = require("../images/Header/JdsLogo.png");
const imgArrowDown = require("../images/MyOrders/OrderArrowDown.png");
const invoiceIcon = require("../images/orderDetails/invoiceIcon.png");
const IconDownloadImg = require("../images/login/downloadIcon.png");
class OrderDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            orderDetails: [],
            orderTimeline: [],
            OrderNumber: '',
            OrderDate: '',
            InvoiceNumber: '',
            // showOrderDetails: false,
            showInvoiceDetails: false,
            InvoiceDate: '',
            InvoiceAmount: '',
            showOrderTimeline: false,
        };
    }
    Pressables = {};


    componentWillUnmount() {
        // Clean up event listener
        if (typeof window !== 'undefined' && window.removeEventListener) {
            window.removeEventListener('popstate', this.handleBackButton);
        }
    }

    handleBackButton = (event) => {
        // Handle back button press - close product details
        if (this.props.showOrderDetails)
            this.props.showOrderDetails(false);

        // Prevent default browser back behavior if needed
        // You can remove this if you want normal browser back behavior
        if (event.state && event.state.page === 'OrderDetails') {
            // Custom handling - stay on current page but close modal/details
            window.history.pushState(event.state, 'Order Details', window.location.pathname);
        }
    }

    async componentDidMount() {
        loaderHandler.showLoader(STRINGS.loading, this);
        if (typeof window !== 'undefined' && window.addEventListener) {
            window.addEventListener('popstate', this.handleBackButton);

            // Push current state to history for better navigation
            const currentState = {
                page: 'OrderDetails',
                productId: this.props.productID,
                timestamp: Date.now()
            };
            window.history.pushState(currentState, 'Order Details', window.location.pathname);
        }

        await this.loadOrderDetails();
        setTimeout(() => {
            loaderHandler.hideLoader();
        }, 1000);
    }

    loadOrderDetails = async () => {
        loaderHandler.showLoader(STRINGS.loading, this);
        const OrderNumber = this.props.OrderNumber;
        const OrderDate = '';
        const InvoiceNumber = this.props.InvoiceNumber;
        const InvoiceID = this.props.InvoiceID;
        const InvoiceAmount = this.props.InvoiceAmount;
        const EstimatedDeliveryDate = this.props.OrderDate;

        this.setState({ InvoiceNumber, InvoiceID, OrderDate, OrderNumber, InvoiceAmount, EstimatedDeliveryDate });

        let resp = await ServerOperations.getOrders('', '', OrderNumber);
        setTimeout(() => {
            this.setState({ orderDetails: resp.ITEMS, orderTimeline: resp.TIMELINE, OrderDate: resp.ORD_DT });
            loaderHandler.hideLoader();
        }, 1000);
    }

    renderHeaderMobile = () => {
        return (
            <View style={{ flexDirection: 'row', alignItems: 'center', padding: 20, alignSelf: "stretch", justifyContent: "space-between" }}>
                <TouchableOpacity onPress={() => window.location = './ClientHomePage'}>
                    <Image source={imgJdsLogo} style={{
                        width: 35.063,
                        height: 37,
                        padding: 1,
                        resizeMode: "contain",
                    }} />
                </TouchableOpacity>
                <TouchableOpacity onPress={() => window.location = './profile'}>
                    <Image source={imgProfile} style={{ width: 20, height: 20, stroke: Styles.appColor1 }}></Image>
                </TouchableOpacity>
            </View>
        )
    }

    getLastOrderItem = () => {
        const TimelineCount = this.state.orderTimeline.length;
        const orderTimelineLastItem = this.state.orderTimeline.map((order, index) => (
            <View>
                {index == TimelineCount - 1 && (order.COLOR == '#6ba461' || order.COLOR == '#D70202') && TimelineCount - 1 != 0 && (
                    <View style={{ alignSelf: 'stretch', backgroundColor: '#FFF', paddingHorizontal: 13, marginTop: 30 }}>
                        <View style={{ flexDirection: 'row', gap: 8, alignSelf: 'stretch' }}>
                            <View style={{ alignItems: 'center', justifyContent: 'center', alignSelf: 'stretch', flexDirection: 'column' }}>
                                <View style={{ height: 40, width: 4, backgroundColor: 'rgba(37, 89, 126, 0.09)', justifyContent: 'center', alignItems: 'center' }} />
                                <View style={{ width: 22, height: 22, borderRadius: 360, backgroundColor: order.COLOR }}></View>
                            </View>
                            <View style={{ justifyContent: 'center', flex: 1 }}>
                                <Text style={[AppStyles.H3Styles]}>{order.STATUS}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.COMMENT}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.DATE} </Text>
                            </View>
                        </View>
                    </View>
                )}
                {index == TimelineCount - 1 && order.COLOR != '#6ba461' && order.COLOR != '#D70202' && (
                    <View style={{ alignSelf: 'stretch', backgroundColor: '#FFF', paddingHorizontal: 22, marginTop: 30 }}>
                        <View style={{ flexDirection: 'row', gap: 16, alignSelf: 'stretch' }}>
                            <View style={{ alignItems: 'center', justifyContent: 'center', alignSelf: 'stretch' }}>
                                <View style={{ height: 70, width: 4, backgroundColor: 'rgba(37, 89, 126, 0.09)', justifyContent: 'center', alignItems: 'center' }}>
                                    <View style={{ width: 22, height: 22, borderRadius: 360, backgroundColor: order.COLOR }}></View>
                                </View>
                            </View>
                            <View style={{ justifyContent: 'center', flex: 1 }}>
                                <Text style={[AppStyles.H3Styles]}>{order.STATUS}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.COMMENT}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.DATE} </Text>
                            </View>
                        </View>
                    </View>
                )}
            </View>
        ));
        return orderTimelineLastItem;
    };

    renderMobile() {
        scale = width / 420;
        var TimelineCount = this.state.orderTimeline.length;
        console.log(TimelineCount);
        const OrderTimeline = this.state.orderTimeline.map((order, index) => (
            <View>
                {index < TimelineCount - 1 && (
                    <View style={{ alignSelf: 'stretch', backgroundColor: '#FFF', paddingHorizontal: 22 }}>
                        <View style={{ flexDirection: 'row', gap: 16, alignSelf: 'stretch' }}>
                            <View style={{ alignItems: 'center', justifyContent: 'center', alignSelf: 'stretch' }}>
                                <View style={{ height: 130, width: 4, backgroundColor: 'rgba(37, 89, 126, 0.09)', justifyContent: 'center', alignItems: 'center' }}>
                                    <View style={{ width: 22, height: 22, borderRadius: 360, backgroundColor: order.COLOR }}></View>
                                </View>
                            </View>
                            <View style={{ justifyContent: 'center', flex: 1 }}>
                                <Text style={[AppStyles.H3Styles]}>{order.STATUS}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.COMMENT}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.DATE} </Text>
                            </View>
                        </View>
                    </View>
                )}
                {index == TimelineCount - 1 && (order.COLOR == '#6ba461' || order.COLOR == '#D70202') && TimelineCount - 1 != 0 && (
                    <View style={{ alignSelf: 'stretch', backgroundColor: '#FFF', paddingHorizontal: 13 }}>
                        <View style={{ flexDirection: 'row', gap: 8, alignSelf: 'stretch' }}>
                            <View style={{ alignItems: 'center', justifyContent: 'center', alignSelf: 'stretch', flexDirection: 'column' }}>
                                <View style={{ height: 70, width: 4, backgroundColor: 'rgba(37, 89, 126, 0.09)', justifyContent: 'center', alignItems: 'center' }} />
                                <View style={{ width: 22, height: 22, borderRadius: 360, backgroundColor: order.COLOR }}></View>
                            </View>
                            <View style={{ justifyContent: 'center', flex: 1 }}>
                                <Text style={[AppStyles.H3Styles]}>{order.STATUS}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.COMMENT}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.DATE} </Text>
                            </View>
                        </View>
                    </View>
                )}
                {index == TimelineCount - 1 && order.COLOR != '#6ba461' && order.COLOR != '#D70202' && (
                    <View style={{ alignSelf: 'stretch', backgroundColor: '#FFF', paddingHorizontal: 22 }}>
                        <View style={{ flexDirection: 'row', gap: 16, alignSelf: 'stretch' }}>
                            <View style={{ alignItems: 'center', justifyContent: 'center', alignSelf: 'stretch' }}>
                                <View style={{ height: 130, width: 4, backgroundColor: 'rgba(37, 89, 126, 0.09)', justifyContent: 'center', alignItems: 'center' }}>
                                    <View style={{ width: 22, height: 22, borderRadius: 360, backgroundColor: order.COLOR }}></View>
                                </View>
                            </View>
                            <View style={{ justifyContent: 'center', flex: 1 }}>
                                <Text style={[AppStyles.H3Styles]}>{order.STATUS}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.COMMENT}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.DATE} </Text>
                            </View>
                        </View>
                    </View>
                )}
            </View>
        ));


        const OrderDetails = this.state.orderDetails.map((order) => (
            <View style={[AppStyles.InvoiceDetailsMainViewStyle, { paddingHorizontal: 20, marginTop: 32 }]}>
                <View style={{ display: 'flex', alignItems: 'center', gap: 24, flexDirection: 'row', width: width - 40 }}>
                    <View style={{ flexDirection: 'column', gap: 6 }}>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>{STRINGS.Item}</Text>
                        {Commons.getTextWidth(order.ITEM_CODE) > (width - 180) && <Text style={[[AppStyles.InvoiceDetailsItemsStyle, { lineHeight: 13 }]]}>  </Text>}
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>{STRINGS.Qty_Details}</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>{STRINGS.Price_Details}</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>{STRINGS.Expiry}</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>{STRINGS.Batch}</Text>
                    </View>
                    {(order.RELEASED_STATUS == 'B' || order.RELEASED_STATUS == 'D') && (
                        <View style={{ flexDirection: 'column', gap: 6 }}>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle2, { fontWeight: '400', textDecorationLine: 'line-through', maxWidth: width - 130 }]}>{order.ITEM_CODE}</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400', textDecorationLine: 'line-through' }]}>{order.ORDERED_QUANTITY} </Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400', textDecorationLine: 'line-through' }]}>{order.PRICE}</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>-</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>-</Text>
                        </View>
                    )}
                    {(order.RELEASED_STATUS == 'B' || order.RELEASED_STATUS == 'D') && (
                        <View style={{ display: 'flex', position: 'absolute', right: 32, flexDirection: 'column', gap: 5, marginTop: 80, width: 100 }}>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontSize: 10.751, textDecorationLine: 'line-through', }]}>{STRINGS.Tax_invoice} {order.TAX}</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontSize: 10.751, textDecorationLine: 'line-through', }]}>{STRINGS.Total_invoice} {order.TOTAL}</Text>
                        </View>
                    )}

                    {(order.RELEASED_STATUS != 'B' && order.RELEASED_STATUS != 'D') && (
                        <View style={{ flexDirection: 'column', gap: 6 }}>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400', maxWidth: width - 130 }]}>{order.ITEM_CODE}</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>{order.QTY}</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>{order.PRICE}</Text>
                            <Text numberOfLines={1} style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400', maxWidth: width - 180 }]}>{Commons.formatExpiryDate(order.EXP_DATE)}</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>{order.BATCH}</Text>
                        </View>
                    )}
                    {(order.RELEASED_STATUS != 'B' && order.RELEASED_STATUS != 'D') && (
                        <View style={{ display: 'flex', position: 'absolute', right: 32, flexDirection: 'column', gap: 5, marginTop: 80, width: 100 }}>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontSize: 10.751, }]}>{STRINGS.Tax_invoice} {order.TAX}</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontSize: 10.751 }]}>{STRINGS.Total_invoice} {order.TOTAL}</Text>
                        </View>
                    )}
                </View>
                <Text style={{}}></Text>
            </View>
        ));
        if (this.state.showInvoiceDetails) {
            return <View style={{ position: 'absolute', top: 0, left: 0, width, height, zIndex: 1001 }}>
                <View style={{ position: 'absolute', right: 20, top: 60, zIndex: 1003 }}>
                    {this.renderCloseButton(() => this.setState({ showInvoiceDetails: false }))}
                </View>
                <InvoiceDetails
                    InvoiceNumber={this.state.InvoiceNumber}
                    InvoiceID={this.state.InvoiceID}
                    InvoiceDate={this.state.InvoiceDate}
                    InvoiceAmount={this.state.InvoiceAmount} />
            </View>
        }
        return (
            [Commons.loadFonts(this),
            <Animatable.View
                animation="slideInUp"
                duration={500}
                style={{
                    flex: 1,
                    position: 'absolute',
                    top: '0%',
                    transform: [{ translateX: -(width - 20) / 2 }, { translateY: -237.5 }],
                    zIndex: 1000,
                    flexDirection: 'column',
                    backgroundColor: 'white',
                    alignItems: 'center',
                    minHeight: '100%'
                }}>
                {!this.showInvoiceDetails && (
                    <View style={{ marginHorizontal: 20 }}>
                        {this.renderHeaderDialog()}
                        <View style={{ display: 'flex', width: width - 40, flexDirection: 'column', paddingHorizontal: 7 }}>
                            <Text style={[AppStyles.H2Styles]}>Order #{this.state.OrderNumber}</Text>
                            <View>
                                <TouchableOpacity onPress={async () => {
                                    this.getInvoiceDetailsItem();
                                    this.setState({ showInvoiceDetails: true });
                                }} style={{ marginTop: 5 }}>
                                    <Text style={[AppStyles.ButtonTextStyles, { color: '#50B0FF', textDecorationLine: 'underline' }]}>Invoice #{this.state.InvoiceNumber}</Text>
                                </TouchableOpacity>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(59, 98, 127, 0.50)', marginTop: 10 }]}>{this.state.detailsOrderDate}</Text>
                            </View>
                        </View>
                        <ScrollView
                            style={{ width: width - 40, marginTop: 32, flexDirection: 'column', gap: 32, height: height - 210 }}
                            contentContainerStyle={{ paddingBottom: 80 }}
                            showsVerticalScrollIndicator={false}>
                            <TouchableOpacity onPress={() => this.setState({ showOrderTimeline: !this.state.showOrderTimeline })}>
                                <View style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', alignSelf: 'stretch', paddingHorizontal: 8, flexDirection: 'row', width: width - 40 }}>
                                    <Text style={[AppStyles.H3Styles]}>{STRINGS.Order_Timeline}</Text>
                                    {this.state.orderTimeline.length > 1 && <Image source={imgArrowDown} style={{ width: 9.6, height: 5.8 }}></Image>}
                                </View>
                                {this.state.showOrderTimeline == true && (
                                    <Animatable.View style={{ flexDirection: 'column', width: width - 40, alignSelf: 'stretch', paddingHorizontal: 8, marginTop: 10 }}
                                        animation="slideInDown"
                                        duration={600}>
                                        {OrderTimeline}
                                    </Animatable.View>
                                )}
                                {this.state.showOrderTimeline == false && (
                                    this.getLastOrderItem()
                                )}
                                <View style={{ display: 'flex', paddingHorizontal: 8, justifyContent: 'flex-start', alignSelf: 'stretch', marginTop: 30 }}>
                                    <Text style={[AppStyles.H3Styles]}>{STRINGS.Order_Details}</Text>
                                </View>
                                <View style={{}}>
                                    {OrderDetails}
                                </View>
                                <Text style={{ height: 56 }}></Text>
                            </TouchableOpacity>
                        </ScrollView>
                    </View>
                )}




            </Animatable.View>
            ]
        )
    }


    render() {
        width = Dimensions.get("window").width;
        height = Dimensions.get("window").height;
        isMobile = Commons.isMobile();
        styles = this.styles();
        if (isMobile) {
            Commons.resizeHandle(window, this, () => {
                width = this.width;
                height = this.height;
            });
            return this.renderMobile();
        }
        width = Commons.getDesktopWidth();
        height = Commons.getDesktopHeight();
        styles = this.styles();
        const TimelineCount = this.state.orderTimeline.length;
        var textWidth = 150;
        // scale = width / 1126;
        // if (scale > 1) scale = 1;
        const lineWidth = 200 * scale;
        const orderTimeline = this.state.orderTimeline.map((item, index) => {
            if (item.STATUS == 'Placed') { textWidth = 130; }
            return (
                <View style={{ alignSelf: 'stretch', backgroundColor: AppStyles.desktopBackgroundColor, marginTop: 50, marginLeft: -45, gap: 25 }}>
                    <View style={{
                        display: 'inline-flex', flexDirection: 'column', justifyContent: 'center',
                        alignItems: index < TimelineCount - 1 ? 'center' : 'flex-end', width: index < TimelineCount - 1 ? lineWidth : lineWidth,
                    }}>
                        <View style={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: lineWidth }}>
                            <Text style={[AppStyles.H3Styles, { textAlign: 'center', fontSize: 16 }]}>{item.STATUS}</Text>
                        </View>
                    </View>

                    {<View style={{
                        alignItems: index == 0 ? "flex-start" : index < TimelineCount - 1 ? "center" : 'flex-end',
                        justifyContent: 'center',
                        width: index == 0 ? 100 : index < TimelineCount - 1 ? lineWidth : lineWidth / 2 + 10,
                        backgroundColor: 'rgba(59, 98, 127, 0.09)', height: 6,
                        marginLeft: index == 0 ? 90 : 0
                    }}>
                        <View style={{ width: 20, height: 20, borderRadius: 360, backgroundColor: item.COLOR }} />
                    </View>}
                    <View style={{
                        display: 'inline-flex', flexDirection: 'column', justifyContent: 'center',
                        alignItems: index < TimelineCount - 1 ? 'center' : 'flex-end', width: index < TimelineCount - 1 ? lineWidth : lineWidth,
                    }}>
                        <View style={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: lineWidth }}>
                            {/* <Text style={[AppStyles.H3Styles, { textAlign: 'center' }]}>{item.STATUS}</Text> */}
                            {/* <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)', textAlign: 'center', width: textWidth }]}>{item.COMMENT}</Text> */}
                            <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)', textAlign: 'center', fontSize: 13 }]}>{item.DATE}</Text>
                        </View>
                    </View>
                </View>
            )
        });

        const orderDetailsHeader = [
            { title: STRINGS.Desktop_Item_Name, width: 285 },
            { title: STRINGS.qty, width: 90 },
            { title: STRINGS.Desktop_Price, width: 90 },
            { title: STRINGS.Desktop_Expiry, width: 105 },
            { title: STRINGS.Desktop_Batch, width: 98 },
            { title: STRINGS.Desktop_Tax, width: 90 },
            { title: STRINGS.Desktop_Total, width: 60 },
        ];
        const widths = [285 * scale, 70 * scale, 70 * scale, 100 * scale, 90 * scale, 80 * scale, 80 * scale];




        const orderDetails = this.state.orderDetails.map((item, index) => {
            const extraStyle = (item.RELEASED_STATUS == 'B' || item.RELEASED_STATUS == 'D') && { color: 'red', textDecorationLine: 'line-through' }
            return (
                <View style={{
                    flexDirection: 'row',
                    paddingVertical: 20,
                    borderTopColor: 'rgba(0, 0, 0, 0.16)',
                    borderTopWidth: index === 0 ? 0 : 1.5,
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    gap: 10,
                }}>
                    <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[0] }, extraStyle]}>{item.ITEM_CODE}</Text>
                    <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[1] }, extraStyle]}>{(item.RELEASED_STATUS == 'B' || item.RELEASED_STATUS == 'D') ? item.ORDERED_QUANTITY : item.QTY}</Text>
                    <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[2] }, extraStyle]}>{item.PRICE}</Text>
                    <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[3] }, extraStyle]}>{item.EXP_DATE}</Text>
                    <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[4] }, extraStyle]}>{item.BATCH}</Text>
                    <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[5] }, extraStyle]}>{item.TAX}</Text>
                    <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[6] }, extraStyle]}>{item.TOTAL}</Text>
                </View>
            )
        });

        return (
            [
                <View
                    style={{
                        alignItems: 'flex-start',
                        minHeight: '100%',
                        backgroundColor: AppStyles.desktopBackgroundColor
                    }}>
                    {!this.state.showInvoiceDetails && (
                        <View style={{ marginHorizontal: 50, marginTop: 80 }}>

                            <View style={{
                                width: 394, gap: 40,
                                flexDirection: 'column',
                            }}>

                                <View style={{ justifyContent: "space-between", flexDirection: "row", width: 910 * scale, alignItems: 'center' }}>
                                    <Text style={[AppStyles.H2Styles]}>Order ID:{this.state.OrderNumber}</Text>
                                    <TouchableOpacity
                                        onPress={() => {
                                            this.props.showOrderDetails(false);
                                        }}
                                        style={{ marginRight: 16, }}>
                                        <Image source={CloseIcon} style={{ width: 14, height: 14, position: 'absolute', top: 0, right: 0 }} />
                                    </TouchableOpacity>
                                </View>

                                <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10, justifyContent: 'space-between', width: 910 * scale }}>
                                    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10 }}>
                                        <View style={{ flexDirection: 'row', justifyContent: 'center', }}>
                                            <Text style={[AppStyles.orderDateDetails, { color: 'rgba(59, 98, 127, 0.50)', }]}>{STRINGS.order_date}: </Text>
                                            <Text style={[AppStyles.orderDateDetails, {}]}>{this.state.OrderDate}</Text>
                                        </View>
                                        <View style={[AppStyles.BodyTextStyles, { backgroundColor: 'rgba(59, 98, 127, 0.50)', height: 20, width: 1 }]} />
                                        <Text style={[AppStyles.estimatedDelv, {}]}>{STRINGS.estimated_delivery} : {this.state.EstimatedDeliveryDate}</Text>
                                    </View>

                                    {this.state.InvoiceNumber != '' && <TouchableOpacity style={[AppStyles.primaryButtonStyle]}
                                        onPress={async () => {
                                            this.setState({ showInvoiceDetails: true });
                                        }}>
                                        <Image source={invoiceIcon} style={{ width: 17, height: 16.484, tintColor: '#fff' }} />
                                        <Text style={[AppStyles.InvoiceButtonText]}>{STRINGS.button_invoice}</Text>
                                    </TouchableOpacity>}
                                </View>
                            </View>
                            <ScrollView style={{ flexDirection: 'row', width: 910 * scale, borderTopColor: '#A3A3A3', borderTopWidth: 1.5, marginTop: 35, }}
                                horizontal={true} showsHorizontalScrollIndicator={true}>
                                {orderTimeline}
                            </ScrollView>

                            <View style={{
                                paddingHorizontal: 40, marginTop: 40, backgroundColor: 'white',
                                borderRadius: 16, paddingBottom: 20,
                                marginVertical: 50
                            }}>
                                <TouchableOpacity
                                    onPress={async () => {
                                        loaderHandler.showLoader(STRINGS.loading, this);
                                        let resp = await ServerOperations.getOrders('', '', this.state.OrderNumber, true);
                                        if (typeof resp.URL === 'string' && resp.URL.startsWith('https://')) {
                                            Linking.openURL(resp.URL);
                                        }
                                        loaderHandler.hideLoader();
                                    }}
                                    style={{ flexDirection: 'row', alignItems: 'center', marginTop: 20, alignSelf: 'flex-end' }}>
                                    <Image source={IconDownloadImg}
                                        style={{ width: 9, height: 9, marginRight: 8, tintColor: AppStyles.hoverColor }} />
                                    <Text style={{
                                        color: AppStyles.hoverColor, fontFamily: AppStyles.fontFamily,
                                        fontSize: 12, fontWeight: "400"
                                    }}>Export To Excel</Text>
                                </TouchableOpacity>
                                <View style={{
                                    display: 'flex', borderTopRightRadius: 16, borderTopLeftRadius: 16,
                                    paddingVertical: 20, flexDirection: 'row', justifyContent: 'flex-start',
                                    borderBottomColor: 'rgba(46, 40, 40, 0.16)',
                                    borderBottomWidth: 1.5,
                                }}>
                                    {orderDetailsHeader.map((header) => {
                                        return (
                                            <Text style={[AppStyles.tblHeaderStyle, { width: header.width }]}>{header.title}</Text>
                                        )
                                    })}
                                </View>

                                <ScrollView style={{ minHeight: 300, maxHeight: height - 260 }} showsVerticalScrollIndicator={true}>
                                    {orderDetails}
                                </ScrollView>
                            </View>
                        </View>
                    )}

                    {this.state.showInvoiceDetails && (
                        <InvoiceDetails
                            InvoiceNumber={this.state.InvoiceNumber}
                            InvoiceID={this.state.InvoiceID}
                            InvoiceDate={this.state.InvoiceDate}
                            InvoiceAmount={this.state.InvoiceAmount}
                            showInvoiceDetails={(show) => this.setState({ showInvoiceDetails: show })}
                        />
                    )}

                </View>

            ]
        );
    }

    getInvoiceDetailsItem = async () => {
        const resp = await ServerOperations.getInvoices('', '', this.state.InvoiceNumber, this.state.InvoiceID);
        this.setState({ InvoiceAmount: resp.AMOUNT, InvoiceDate: resp.DATE });

    }

    renderPart1 = () => {
    }

    renderPart1Mobile = () => {

    }

    renderDownloadButton = () => {
        // return (
        //     <TouchableOpacity style={{
        //          width: 53, height: 56,
        //         justifyContent: 'center', alignItems: 'center',
        //         borderRadius: 50, backgroundColor: '#92D8F5',
        //         boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.15)',
        //     }}
        //         onPress={() => Linking.openURL(this.state.invoiceURL)}>
        //         <Image source={imgDownloadIcon} style={{ width: 56, height: 56, marginTop: 4 }} />
        //     </TouchableOpacity>
        // )
    }




    renderCloseButton = (onPress) => {
        return (
            <TouchableOpacity
                onPress={onPress}
                activeOpacity={0.6}
                hitSlop={{ top: 24, bottom: 24, left: 24, right: 24 }}
                style={{
                    width: 48,
                    height: 48,
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                <Image source={CloseIcon} style={{ width: 20, height: 20 }} resizeMode="contain" />
            </TouchableOpacity>
        )
    }

    renderHeaderDialog = () => {
        return (
            <SafeAreaInsetsContext.Consumer>
                {(insets) => (
                    <View style={{
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                        alignSelf: "stretch",
                        width,
                        paddingHorizontal: 16,
                        paddingTop: 12 + Math.max((insets && insets.top) || 0, 12),
                        paddingBottom: 8,
                    }}>
                        {this.renderCloseButton(() => this.props.showOrderDetails(false))}
                    </View>
                )}
            </SafeAreaInsetsContext.Consumer>
        )
    }



    styles = () => ({
        container: {
            flex: 1,
            alignItems: "center",
            backgroundColor: WHITE
        },
        image: {
            flex: 1,
            resizeMode: 'contain',
            justifyContent: 'center',
            height: 590,
        }
    });
}



export default OrderDetails;
